<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
        <div v-for="(subject,index) in pageData.subject">
            <van-divider>项目{{index+1}}</van-divider>
            <van-cell-group>
                <van-cell title="项目" :label="subject.subject_name" />
                <van-cell title="参赛队员"   />
                <div class="memberResultWrap" v-show="subject.yundongyuan.length>0">
                    <div class="memberLi" v-for="(yundongyuan ,index) in subject.yundongyuan">
                        运动员{{index+1}}
                        <van-tag

                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                type="primary"
                                @close="subject.yundongyuan.splice(index,1)"
                        > {{yundongyuan.name}} {{yundongyuan.num}}
                        </van-tag>
                    </div>
                </div>

                <van-cell title="教练员"  />

                <div class="memberResultWrap" v-show="subject.jiaolian.length>0">
                    <div class="memberLi" v-for="(jiaolian ,index) in subject.jiaolian">
                        教练员{{index+1}}
                        <van-tag

                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                type="primary"
                        > {{jiaolian.name}} {{jiaolian.num}}
                        </van-tag>
                    </div>
                </div>
                <van-cell title="替补队员"   />

                <div class="memberResultWrap" v-show="subject.tbydy.length>0">
                    <div class="memberLi" v-for="(tbydy ,index) in subject.tbydy">
                        替补运动员{{index+1}}
                        <van-tag

                                :key="index"
                                round
                                color="#fff"
                                text-color="#666"
                                size="large"
                                type="primary"
                        > {{tbydy.name}} {{tbydy.num}}
                        </van-tag>
                    </div>
                </div>


                <van-cell title="自选音乐试听" is-link v-if="subject.sf_music_status==false&&subject.music_url" @click="playMusicUrl=subject.music_url;subject.music_url_played=true;showMusic=true" >
                   <span style="color:#f00">点击试听</span>
                </van-cell>
                <van-cell title="规定音乐试听" is-link v-if="subject.sf_music_status==true&&subject.music_url"  @click="playMusicUrl=subject.music_url;subject.music_url_played=true;showMusic=true" >
                   <span style="color:#f00">点击试听</span>
                </van-cell>

                <!-- <van-cell title="自选音乐" is-link v-if="subject.sf_music_status==false&&subject.music_url" >
                    <a :href="subject.music_url">已上传</a>
                </van-cell>
                <van-cell title="自选音乐" is-link v-if="subject.sf_music_status==false&&subject.music_url==''&&subject.music_status==1" @click='showMusicDialog=true;musicSubjectId=subject.id' >
                    <em style="color: #ff0000">现在上传/现场提交</em>
                </van-cell>
                <van-cell title="音乐试听" is-link @click="listen(subject)" v-if="subject.sf_music_status==false&&subject.music_url&&subject.music_status==1" >
                    <em style="color: #ff0000">未试听,请点击确认试听</em>
                </van-cell>
                <van-cell title="音乐试听"  v-if="subject.sf_music_status==false&&subject.music_url&&subject.music_status==2" >
                     已试听
                </van-cell>
                <van-cell title="音乐试听"  v-if="subject.sf_music_status==false&&subject.music_status==3" >
                     现场提交并核对
                </van-cell> -->
                <!-- <van-cell title="现场照片服务" :value="subject.photo_service==1?'是':'否'" /> -->
            </van-cell-group>
        </div>
        <div style="padding: 20px;">
            <van-button type="primary"  size="large" v-if="pageData.confirm_2==2" @click.stop="save">信息无误 我已确认</van-button>
            <van-button type="primary" size="large"  plain v-else >信息已确认</van-button>
            <van-button size="large" plain style="margin: 10px 0" @click.stop="edit">信息需要修改</van-button>
            <van-button size="large" plain style="margin: 10px 0" @click.stop="goIndex">返回首页</van-button>
        </div>
        <van-dialog title="自选音乐" :visible.sync="showMusicDialog">
            <el-upload
                    class="upload-demo"
                    style="width:100%"
                    action=""
                    accept="audio/mp3"
                    :show-file-list="false"
                    :before-upload = "onReadMusic"
            >
                <van-button type="primary" size="large"  plain>现在上传</van-button>
            </el-upload>
            <van-button size="large" @click="musicNoSubmit()" plain style="margin: 10px 0" >现场提交</van-button>
        </van-dialog>
        <div class="mask" v-if="loadding">
            <van-loading type="spinner" color="white" />
        </div>


        <van-popup
                v-model="showMusic"
                closeable
                position="bottom"
                :style="{ height: '30%' }"
        >
            <div style="text-align: center">
                <audio autoplay style="margin: 10px auto" v-if="playMusicUrl&&showMusic" :src="playMusicUrl" controls="controls"></audio>
            </div>
        </van-popup>

    </div>
</template>

<style scoped="">
    .upload-demo>>>.el-upload{width: 100%}
    .mask>>>.van-loading{ margin: 100px auto}


    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        /* height: 36px; */
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }
</style>
<script>
    import {
            Cell, CellGroup,Field,RadioGroup,Radio,DatetimePicker,Picker,NoticeBar,Button,Dialog,Loading
    } from 'vant';
    export default {
        name: 'saiConfirmDetai2',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Field.name]: Field,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [NoticeBar.name]: NoticeBar,
            [Button.name]: Button,
            [Dialog.name]: Dialog,
            [Loading.name]: Loading,
        },
        data: function () {
            return {
                pageData:{
                    'id' : this.$route.query.id,
                    'subject' :[],
                },
                formData:{
                    'id' : this.$route.query.id,
                },
                musicSubjectId:0,
                showTime:false,
                playMusicUrl:'',
                timeField:'',
                showStation:false,
                stationField:'',
                showMusicDialog:false,
                showMusic:false,
                loadding:false,
            }
        },
        mounted: function () {
            let that = this;
            document.title = "姓名信息确认";
            this.$api.get('/api/sai/confirmsubjectdetail', {
                'id':that.pageData.id
            }, r => {
                this.pageData = r.data;
            });

        },
        methods: {
            goIndex:function () {
                this.$router.push({
                    'name' :'saiConfirmManage',
                    'query':{}
                })
            },

            save:function () {
                let that = this;
                let error = false;
                this.pageData.subject.filter((item,index) =>{
                    if(item.music_url && !item.music_url_played){
                        that.$toast.fail('请先试听确认项目'+(index+1)+'的音乐');
                        error = true;
                        return ;
                    }
                })
                if(error){
                    return ;
                }
                Dialog.confirm({
                    title: '确认',
                    message: '您确定信息准确无误吗?提交后不得修改!'
                }).then(() => {
                    // on confirm
                    that.$api.post('/api/sai/confirmsubjectaction', this.formData, r => {
                        that.$router.push({'name':'saiConfirm','query':{'id':that.pageData.id}});
                    },r=>{
                        that.$toast.fail(r.msg);
                    });
                }).catch(() => {
                    // on cancel
                });


            },
            edit:function () {
                let that = this;
                this.$router.push({
                    'name' :'saiConfirmQr1',
                    'query':{'id':that.pageData.id}
                })
            }
            ,onReadMusic:function (file,e) {
                console.log('e');
                console.log(e);
                console.log(file);
                let that = this;
                let formdata = new FormData();
                console.log(file);
                that.loadding = true;
                formdata.append('upfile',file);
                formdata.append('fieldName','upfile');
                formdata.append('user_id',that.pageData.userid);
                that.$api.upload('https://api.ccago.cn/core/attachment/ccaUploadFile',formdata, r => {
                    that.$message.success('操作成功');
                    that.$api.post('/wxapi_sai_updatemusic', {
                        music:r.data.url,
                        name:file.name,
                        size:r.data.size,
                        id:that.musicSubjectId
                    }, r2 => {
                        that.$message.success('操作成功');
                        that.$router.go(0);
                        that.loadding = false;
                    },r2=>{
                        that.$toast.fail(r2.msg);
                        that.loadding = false;
                    });
                },r=>{
                    that.$toast.fail(r.msg);
                    that.loadding = false;
                });
                return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
            },listen:function (subject) {
                let that = this;
                that.$api.post('/wxapi_sai_subjectmusicstatusaction',{
                    id:subject.id,
                    status:2
                }, r => {
                    location.href = subject.music_url;
                },r=>{
                    that.$toast.fail(r.msg);
                });
            },musicNoSubmit:function () {
                let that = this;
                that.$api.post('/wxapi_sai_subjectmusicstatusaction',{
                    id:that.musicSubjectId,
                    status:3
                }, r => {
                    that.$router.go(0);
                },r=>{
                    that.$toast.fail(r.msg);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// saiConfirmDetail2.vue?30803268